import React from 'react';

function PageLoader({className=""}) {
	return (
		<div className={`pageLoaderWrapper center ${className}`}>
			  <div class="pageloader"></div> 
		</div>
	);
}

export default PageLoader;
